<template>
    <div class="home">
        <h1>Thank You!</h1>
        <p>You will be redirected.</p>
    </div>
</template>